import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
export default defineComponent({
    name: 'ScenicFoodInfoDetailContent',
    setup: function () {
        var info = ref(null);
        var route = useRoute();
        onMounted(function () {
            var detail = route.params;
            if (detail) {
                info.value = detail;
            }
        });
        return {
            info: info
        };
    },
});
